<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>

            <section class="client-section steps">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title word-keep-all">
                            후원 아동은 성장 단계별 <br class="d-md-none">
                            필요한 도움을 받으며 <br class="d-md-none d-lg-block" />
                            자립할 때까지 <br class="d-md-none">
                            함께합니다.
                        </h2>
                    </div>
                    <v-row>
                        <v-col v-for="(stage, index) in stages" :key="index" alt="" cols="6" lg="3">
                            <v-card color="transparent" tile flat>
                                <v-img :src="stage.image" max-width="282" class="border-radius-16 mx-auto" />
                                <v-card-title class="justify-center text-center pb-0 pt-lg-24">
                                    <div class="tit tit--sm primary--text">
                                        {{ stage.title }}
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <program-list :items="programs" />
                </v-container>
            </section>
        </div>
        <section>
            <bottom-banner :item="banner" />
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ProgramList from "@/components/client/business/program-list.vue";
import BottomBanner from "@/components/client/business/bottom-banner.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ProgramList,
        BottomBanner,
    },
    data() {
        return {
            visual: {
                sh: "해외사업",
                tabActive: "지역개발사업",
                text: "우리는 글로벌 연대, 지속 가능한 개발과 <br />나눔을 만들어 갑니다.",
                bg: "/images/business/overseas/visual.jpg",
                mobile: "/images/business/overseas/mobile-visual.jpg"
            },
            intro: {
                image: "/images/business/overseas/region/intro.jpg",
                title: "지역개발사업",
                texts: "지역개발사업을 통해 지역 사회의 소외된 아동과 주민들에게 필요한 교육, 주거, 보건ㆍ의료 등의 서비스를 종합적으로 <br class='d-none d-xl-block' />지원하고 사회적·경제적 역량을 강화하여 주민들이 자립할 수 있는 기반 마련을 지원합니다. 또한, 지속 가능한 성장과 <br class='d-none d-xl-block' />안정적인 삶을 위한 다양한 프로그램을 운영하여, 주민들이 더 나은 미래를 향해 나아갈 수 있도록 돕고 있습니다.",
            },
            stages: [
                {
                    image: "/images/business/overseas/region/stage-1.jpg",
                    title: "유아기",
                },
                {
                    image: "/images/business/overseas/region/stage-2.jpg",
                    title: "초등기",
                },
                {
                    image: "/images/business/overseas/region/stage-3.jpg",
                    title: "청소년기",
                },
                {
                    image: "/images/business/overseas/region/stage-4.jpg",
                    title: "아동/마을자립",
                },
            ],
            programs: [
                {
                    image: "/images/business/overseas/region/program-1.jpg",
                    title: "희망의 집짓기 사업",
                    texts: [
                        "열악한 주거환경의 지역사회에 안전한 주거 공간을 제공합니다. <br class='d-none d-xl-block' />주택을 새로 짓거나 개·보수하여 기본 생활권을 보장하고 <br class='d-none d-xl-block' />지역주민의 삶의 질을 높이고자 합니다.",
                        //
                    ],
                },
                {
                    image: "/images/business/overseas/region/program-2.jpg",
                    title: "그룹홈 지원 사업",
                    texts: [
                        "가정의 보호를 받을 수 없는 아동들이 안전하고 안정적인 환경에서 <br class='d-none d-xl-block' />생활할 수 있도록 그룹홈을 지원하여 심리적·정서적 지원을 포함한 <br class='d-none d-xl-block' />종합적인 돌봄을 제공합니다.",
                        //
                    ],
                },
                {
                    image: "/images/business/overseas/region/program-3.jpg",
                    title: "교육 지원 사업",
                    texts: [
                        "교육 기회가 부족한 지역 아동들에게 학습 환경과 교육 자원을 제공합니다. <br class='d-none d-xl-block' />교실 확충, 교사 양성 프로그램 등을 통해 더 나은 교육을 위한 토대를 <br class='d-none d-xl-block' />마련하고 있습니다",
                        //
                    ],
                },
                {
                    image: "/images/business/overseas/region/program-4.jpg",
                    title: "보건ㆍ의료 사업",
                    texts: [
                        "기초적인 보건 의료 서비스가 부족한 지역에서, <br class='d-none d-xl-block' />전문적인 의료 사업을 통해 건강을 위협하는 <br class='d-none d-xl-block' />질병을 예방하고 아동과 주민들의 생명을 보호합니다.",
                        //
                    ],
                },
            ],
            banner: {
                image: "/images/business/overseas/region/bottom-banner.jpg",
                mobile: "/images/business/overseas/region/bottom.jpg",
                white: true,
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.client-section.steps {
    background-color: #fafafa;
}
</style>